import { STEP } from '../@types/state'
import { ProgressType } from '../@types/progress'
import { WizardFlowType } from '../@types/wizardFlowType'

const defaultProgressMap: ProgressType = {
  [STEP.LOCATION]: { previous: 10, current: 23, next: 30 },
  [STEP.AREA]: { previous: 23, current: 30, next: 40 },
  [STEP.LAND_DEVELOPMENT_STATUS]: { previous: 30, current: 40, next: 50 },
  [STEP.LAND_DEVELOPMENT_POTENTIAL]: { previous: 40, current: 50, next: 60 },
  [STEP.LAND_LAYOUT]: { previous: 50, current: 60, next: 70 },
  [STEP.INTENT]: { previous: 60, current: 70, next: 75 },
  [STEP.RENT_OUT_INTENT]: { previous: 70, current: 75, next: 80 },
  [STEP.RENT_OUT_REINFORCEMENT]: { previous: 75, current: 80, next: 82 },
  [STEP.EQUITY]: { previous: 80, current: 82, next: 84 },
  [STEP.INCOME]: { previous: 82, current: 84, next: 88 },
  [STEP.EMPLOYMENT]: { previous: 84, current: 88, next: 92 },
  [STEP.TIME_HORIZON]: { previous: 88, current: 92, next: 96 },
  [STEP.OWNER]: { previous: 92, current: 96, next: 100 },
  [STEP.CONTACT]: { previous: 96, current: 100, next: 100 },
}

const ibwProgressMap: ProgressType = {
  [STEP.LOCATION]: { previous: 10, current: 15, next: 20 },
  [STEP.AREA]: { previous: 15, current: 20, next: 25 },
  [STEP.LAND_DEVELOPMENT_STATUS]: { previous: 20, current: 25, next: 30 },
  [STEP.LAND_DEVELOPMENT_POTENTIAL]: { previous: 25, current: 30, next: 40 },
  [STEP.LAND_LAYOUT]: { previous: 30, current: 40, next: 50 },
  [STEP.INTENT]: { previous: 40, current: 50, next: 60 },
  [STEP.RENT_OUT_INTENT]: { previous: 52, current: 63, next: 70 },
  [STEP.RENT_OUT_REINFORCEMENT]: { previous: 63, current: 70, next: 72 },
  [STEP.SELL_INTENT]: { previous: 50, current: 60, next: 70 },
  [STEP.DEV_COM_OFFER]: { previous: 60, current: 70, next: 80 },
  [STEP.EQUITY]: { previous: 50, current: 60, next: 70 },
  [STEP.INCOME]: { previous: 60, current: 70, next: 80 },
  [STEP.EMPLOYMENT]: { previous: 70, current: 80, next: 90 },
  [STEP.TIME_HORIZON]: { previous: 80, current: 90, next: 100 },
  [STEP.OWNER]: { previous: 90, current: 100, next: 100 },
  [STEP.CONTACT]: { previous: 100, current: 100, next: 100 },
}

const progressMap: { [k in WizardFlowType]: ProgressType } = {
  [WizardFlowType.RLE]: defaultProgressMap,
  [WizardFlowType.IBW]: ibwProgressMap,
  [WizardFlowType.SOLAR]: {
    // TODO add missing mapping here
  },
}

export { progressMap }
